<h1 mat-dialog-title>Edit Collection</h1>
<div mat-dialog-content [formGroup]="addCollectionForm">
  <mat-form-field appearance="outline" color="accent" class="name-input" required>
    <mat-label>Name</mat-label>
    <input matInput formControlName="name" />
  </mat-form-field>
  <br />
  <mat-form-field appearance="outline" color="accent" class="description-input">
    <mat-label>Description</mat-label>
    <textarea matInput formControlName="description"></textarea>
  </mat-form-field>

  <br />
  <mat-checkbox formControlName="private" color="accent">Private</mat-checkbox>
  <br />
  <mat-form-field
    appearance="outline"
    *ngIf="addCollectionForm.get('private')?.value"
    color="accent"
    class="access-list">
    <mat-label>Access List</mat-label>
    <mat-chip-grid #chipGrid aria-label="Access List">
      <mat-chip-row *ngFor="let user_id of accessList.value" [removable]="true" (removed)="removeAccess(user_id)">
        {{ getEmail(user_id) }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
      <input
        placeholder="Search for users..."
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [formControl]="searchControl"
        [matAutocomplete]="auto"
        (matChipInputTokenEnd)="addAccessFromInput($event)" />
    </mat-chip-grid>
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="addAccess($event.option.value)"
      [displayWith]="displayUser">
      <mat-option *ngFor="let user of filteredUsers$ | async" [value]="user">
        {{ user.email }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <h3>Dimensions</h3>
  <button mat-raised-button color="accent" (click)="addDimension()">Add Dimension</button>
  <div formArrayName="dimensions" class="dimensions-container">
    <div *ngFor="let dimension of dimensions.controls; let i = index" [formGroupName]="i" class="dimension-form-group">
      <mat-form-field appearance="outline" color="accent" class="dimension-name">
        <mat-label>Dimension Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent" class="dimension-description">
        <mat-label>Dimension Description</mat-label>
        <input matInput formControlName="description" />
      </mat-form-field>
      <button mat-icon-button (click)="removeDimension(i)" color="accent">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button color="accent" (click)="saveForm()">Save</button>
</div>
